import { H3 } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import { useRouter } from 'next/router';

import { FilterWrapper, StyledButton, Wrapper } from './styles';
import constants from '../../../../ahm-constants';

const { URLS } = constants;

const FILTER_DATA = [
  { label: 'All', to: URLS.SALES.ARTICLE_HUB },
  { label: 'Travel', to: `${URLS.SALES.ARTICLE_HUB}/travel` },
  { label: 'Health', to: `${URLS.SALES.ARTICLE_HUB}/health` },
  { label: 'Pet', to: `${URLS.SALES.ARTICLE_HUB}/pet` },
  { label: 'Home', to: `${URLS.SALES.ARTICLE_HUB}/home` },
  { label: 'Car', to: `${URLS.SALES.ARTICLE_HUB}/car` },
  { label: 'Life', to: `${URLS.SALES.ARTICLE_HUB}/life` },
  { label: 'Income', to: `${URLS.SALES.ARTICLE_HUB}/income-protection` },
];

const TypeFilter = () => {
  const { asPath } = useRouter();

  return (
    <Wrapper>
      <H3 variant="marginBottomSpacer8" looksLike="h4">
        Article categories
      </H3>
      <FilterWrapper>
        {map(({ label, to }) => {
          const isActive = asPath === to;
          const variants = isActive ? ['black'] : ['white', 'border'];
          return (
            <StyledButton variant={[...variants]} to={to} key={label}>
              {label}
            </StyledButton>
          );
        }, FILTER_DATA)}
      </FilterWrapper>
    </Wrapper>
  );
};

export default TypeFilter;
